/**
 * @file Files component
 * @author Heino Lenting
 */
import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertsService } from '../../core/alerts.service';
import { OverlayService } from '../../core/overlay.service';
import { FilesService } from '../../base/files.service';
import { ResourceService } from '../../resource.service';
/**
 * Class for the files component
 */
var FilesComponent = /** @class */ (function () {
    /**
     * Constructs an FilesComponent
     */
    function FilesComponent(alertsService, overlayService, resourceService, filesService) {
        this.alertsService = alertsService;
        this.overlayService = overlayService;
        this.resourceService = resourceService;
        this.filesService = filesService;
        this.fileFormControl = new FormControl();
        this.isRequired = false;
        this.configuration = {
            instruction: 'instructions/standaard/core/social/files/files'
        };
        /** The available files */
        this.uploads = [];
    }
    Object.defineProperty(FilesComponent.prototype, "value", {
        /** Gets the field value. */
        get: function () {
            return undefined;
        },
        /** Sets the field value. */
        set: function (value) {
            if (value) {
                // Do upload via files service
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called directly after the creation of this component
     */
    FilesComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    /**
     * Method to get the current files
     * @param item The Entity
     */
    FilesComponent.prototype.refresh = function () {
        var _this = this;
        // Get current files from files service
        this.filesService.getFiles(undefined).then(function (uploads) {
            _this.uploads = uploads;
        }).catch(function (error) {
            _this.alertsService.createAlert('warning', 'APP.SOCIAL.ACTION_FAILED', error.message);
        });
    };
    /**
     * Method to delete a file
     * @param id The ID of the file
     */
    FilesComponent.prototype.delete = function (id) {
        var _this = this;
        // Remove file
        this.filesService.deleteUpload(undefined, id).then(function () {
            _this.refresh();
            _this.alertsService.createAlert('success', 'APP.INPUTS.FILE_SUCCESSFULLY_DELETED');
        }).catch(function (error) {
            _this.alertsService.createAlert('warning', 'APP.INPUTS.FILE_NOT_SUCCESSFULLY_DELETED', error.message);
        });
    };
    /**
     * Method to download a file
     * @param id The ID of the file
     */
    FilesComponent.prototype.download = function (id) {
        // TODO: initiate a (new) window open (with path to file)
        var _this = this;
        // Inform user about starting the download
        this.alertsService.createAlert('success', 'APP.SOCIAL.DOWNLOAD_FILE_STARTED');
        this.filesService.getFile(null).then(function () {
            _this.refresh();
            _this.alertsService.createAlert('success', 'APP.SOCIAL.FILE_SUCCESSFULLY_DOWNLOADED');
        }).catch(function (error) {
            _this.alertsService.createAlert('warning', 'APP.SOCIAL.FILE_NOT_SUCCESSFULLY_DOWNLOADED', error.message);
        });
    };
    /**
     * Method to show profile info of a user belonging to a file
     * @param entityID The entityID of the user
     */
    FilesComponent.prototype.showProfile = function () {
        console.log('files');
        this.overlayService.goToEntity(this.resourceService.resource);
    };
    return FilesComponent;
}());
export { FilesComponent };
